import '../styles/Sliders.css';
import { useState, useEffect, useRef } from 'react';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export default function Sliders({ images }) {
    const [currentImage, setCurrentImage] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
    const intervalRef = useRef(null);

    useEffect(() => {
        startAutoplay();
        return () => stopAutoplay();
    }, [images.length]);

    const startAutoplay = () => {
        intervalRef.current = setInterval(() => {
            goToNext();
        }, 6000);
    };

    const stopAutoplay = () => {
        clearInterval(intervalRef.current);
    };

    const goToNext = () => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentImage((prevImage) => (prevImage + 1) % images.length);
        setTimeout(() => setIsAnimating(false), 1000);
    };

    const goToPrev = () => {
        if (isAnimating) return;
        setIsAnimating(true);
        setCurrentImage((prevImage) => (prevImage - 1 + images.length) % images.length);
        setTimeout(() => setIsAnimating(false), 1000);
    };

    const goToSlide = (index) => {
        if (isAnimating || index === currentImage) return;
        setIsAnimating(true);
        setCurrentImage(index);
        setTimeout(() => setIsAnimating(false), 1000);
    };

    const current = images[currentImage];

    return (
        <section className="hero-section" onMouseEnter={stopAutoplay} onMouseLeave={startAutoplay}>
            <div className="hero-slider">
                {images.map((image, index) => (
                    <div 
                        key={index} 
                        className={`hero-slide ${index === currentImage ? 'active' : ''} ${index === (currentImage - 1 + images.length) % images.length ? 'prev' : ''}`}
                    >
                        <div className="hero-slide-bg" style={{ backgroundImage: `url(${image.url})` }}></div>
                        <div className="hero-overlay"></div>
                    </div>
                ))}
            </div>
            
            <div className="hero-content">
                <div className="hero-text-wrapper">
                    {/* <span className="hero-tagline">WASA</span> */}
                    <h1 className="hero-title">{current.title}</h1>
                    <p className="hero-description">{current.body}</p>
                    <a href={current.link} target='_blank' rel="noreferrer" className="hero-cta">
                        {current.ctaTxt}
                        <span className="cta-arrow">→</span>
                    </a>
                </div>
            </div>

            <div className="hero-nav">
                <button className="hero-nav-btn prev" onClick={goToPrev} aria-label="Previous slide">
                    <FaChevronLeft />
                </button>
                <div className="hero-dots">
                    {images.map((_, index) => (
                        <button 
                            key={index} 
                            className={`hero-dot ${index === currentImage ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}
                            aria-label={`Go to slide ${index + 1}`}
                        />
                    ))}
                </div>
                <button className="hero-nav-btn next" onClick={goToNext} aria-label="Next slide">
                    <FaChevronRight />
                </button>
            </div>

            {/* <div className="hero-scroll-indicator">
                <span>Scroll</span>
                <div className="scroll-line"></div>
            </div> */}
        </section>
    );
};